import { render, staticRenderFns } from "./quick-edit-project.vue?vue&type=template&id=132d7e32"
import script from "./quick-edit-project.vue?vue&type=script&lang=js"
export * from "./quick-edit-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports